import { toast as sonnerToast } from 'sonner';

/**
 * App-wide toast helper.
 *
 * Error toasts stay on screen until the user explicitly dismisses them
 * (the Toaster renders a close button). In a production system an error must
 * never silently vanish before someone has seen and dealt with it. Success and
 * info toasts keep sonner's normal auto-dismiss behaviour.
 *
 * Use this instead of importing `toast` directly from `sonner`.
 */
export const toast = Object.assign(
  (...args: Parameters<typeof sonnerToast>) => sonnerToast(...args),
  sonnerToast,
  {
    error: (
      message: Parameters<typeof sonnerToast.error>[0],
      options?: Parameters<typeof sonnerToast.error>[1],
    ) => sonnerToast.error(message, { duration: Infinity, ...options }),
  },
);
